import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!
  const _component_page_section = _resolveComponent("page-section")!

  return (_openBlock(), _createBlock(_component_page_section, {
    class: "photoslider",
    revealOnScroll: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Slider, {
        slides: _ctx.slides,
        startAt: _ctx.startAt
      }, null, 8, ["slides", "startAt"])
    ]),
    _: 1
  }))
}